import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiVolume2, FiVolumeX } = FiIcons;
const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/f7315b2618eeea0d7624b59aa836285252d672c0343d1c096b331e8c17ecf5d6392c31cbae054d7df53e259ef3b3cc0f/images/aW1hZ2UvanBlZw==/5c90fd6516f7f2702958876fe992eedb.jpg';

function TopBar({ muted, onToggleMute, playCount, countLoading }) {
  return (
    <header className="topbar">
      <a className="brand" href="https://mpesport.com/" target="_blank" rel="noreferrer">
        <img src={LOGO_URL} alt="MPESPORT 時代德毅能體育會" />
        <span>大灣區詠春家文化廣場 2026</span>
      </a>

      <div className="topbar-actions">
        <div className="live-count" aria-live="polite">
          <span className="live-dot" />
          <SafeIcon icon={FiUsers} />
          <span>{countLoading ? '同步中' : `線上詠春挑戰 · 累計 ${playCount.toLocaleString()} 人次參與`}</span>
        </div>
      </div>
    </header>
  );
}

export default TopBar;